import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { DefaultFormFields, FormControl, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { updateProposalName } from 'api/operations/enrollmentService';
import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';

interface SaveProposalFields extends DefaultFormFields {
  name: FormControl<string>;
}

export type ModalType = 'SAVE' | 'RENAME';

export class UpdateProposalModalStore {
  rootStore: RootStore;
  saveForm: FormController<SaveProposalFields>;
  loading = false;
  cartId = '';
  periodId = '';
  rateSegment: RateSegment = 'GROUP';
  showSaveProposalModal = false;
  modalType: ModalType = 'SAVE';

  setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  setShowSaveProposalModal(showSaveProposalModal: boolean): void {
    this.showSaveProposalModal = showSaveProposalModal;
  }

  openSaveProposalModal(name: string, cartId: string, rateSegment: RateSegment): void {
    this.modalType = 'SAVE';
    this.setShowSaveProposalModal(true);

    this.cartId = cartId;
    this.rateSegment = rateSegment;

    this.saveForm.populateFields({ name });
  }

  openRenameProposalModal(name: string, cartId: string, periodId: string): void {
    this.modalType = 'RENAME';
    this.setShowSaveProposalModal(true);

    this.cartId = cartId;
    this.periodId = periodId;

    this.saveForm.populateFields({ name });
  }

  // Save template
  async saveBrokerCart(): Promise<void> {
    this.setLoading(true);
    const res = await this.rootStore.cartStoreV2.saveBrokerCart(
      this.cartId,
      this.saveForm.fields.name.value,
      this.rateSegment,
    );
    runInAction(() => {
      if (res.data?.saveBrokerCart) {
        this.setLoading(false);
        this.setShowSaveProposalModal(false);
      }
    });
  }

  async renameProposal(periodId: string): Promise<void> {
    this.setLoading(true);
    await Promise.all([
      this.rootStore.cartStoreV2.updateCartName(this.cartId, this.saveForm.fields.name.value),
      updateProposalName(periodId, this.cartId, this.saveForm.fields.name.value),
    ]);
    runInAction(() => {
      this.setLoading(false);
    });
  }

  closeSaveProposalModal(): void {
    this.setShowSaveProposalModal(false);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    this.saveForm = new FormController({
      name: new FormControl<string>('', { optional: false }),
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
